import { Modal, List, Typography, Tag, Space, Alert } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';

interface ItemError {
  title: string;
  messages: string[];
}

export function showItemsErrorModal(errorsList: ItemError[]) {
  Modal.confirm({
    icon: <ExclamationCircleOutlined style={{ color: '#faad14' }} />,
    title: (
      <Space direction="vertical" size={0}>
        <Typography.Title level={4} style={{ marginBottom: 0 }}>
          Alguns itens não puderam ser removidos
        </Typography.Title>

        <Typography.Text type="secondary">
          Corrija as pendências abaixo antes de tentar novamente.
        </Typography.Text>
      </Space>
    ),
    content: (
      <div className="scroll">
        <div
          style={{
            marginTop: 16,
            maxHeight: 420,
            paddingRight: 12,
            overflowY: 'auto',
          }}
        >
          <List
            dataSource={errorsList}
            split={false}
            renderItem={(err) => (
              <List.Item style={{ padding: 0, marginBottom: 12 }}>
                <Alert
                  type="warning"
                  showIcon
                  message={
                    <Space
                      direction="vertical"
                      size={4}
                      style={{ width: '100%' }}
                    >
                      <Typography.Text strong style={{ fontSize: 15 }}>
                        <Tag style={{ fontWeight: 600 }}>{err.title}</Tag>
                      </Typography.Text>
                    </Space>
                  }
                  description={
                    <ul style={{ paddingLeft: 20, margin: '8px 0' }}>
                      {err.messages.map((message, index) => (
                        <li
                          key={`${message}-${index}`}
                          style={{ marginBottom: 4 }}
                          title={message}
                        >
                          {message}
                        </li>
                      ))}
                    </ul>
                  }
                  style={{
                    width: '100%',
                    borderRadius: 8,
                  }}
                />
              </List.Item>
            )}
          />
        </div>
      </div>
    ),
    okText: 'Entendido',
    okButtonProps: { type: 'primary' },
    cancelButtonProps: { style: { display: 'none' } },
    width: 640,
  });
}
